// extracted by mini-css-extract-plugin
export default {"container":"NewScheme_container__YgqXM","scheme":"NewScheme_scheme__Vz1UU","bookingListButton":"NewScheme_bookingListButton__g4R0V","legend":"NewScheme_legend__fkejU"};